import React from "react"
import tw, { theme } from "twin.macro"
import { createGlobalStyle } from "styled-components"

export const ButtonStyles = createGlobalStyle({
  ":root": {
    "--button-text": theme(`colors.white`),
    "--button-primary": theme(`colors.purple`),
    "--button-primary-outline": theme(`colors.purple`),
    "--button-primary-disabled": theme(`colors.inactive-purple`),
    "--button-secondary": theme(`colors.dark-purple`),
    "--button-secondary-disabled": theme(`colors.base-3`),
    "--button-secondary-outline": theme(`colors.dark-purple`),
    "--button-warning-white": theme(`colors.white`),
    "--button-warning-white-outline": theme(`colors.white`),
    "--button-warning": theme(`colors.red`),
    "--button-warning-disabled": theme(`colors.light-red`),
    "--button-warning-outline": theme(`colors.red`),
    "--button-success": theme(`colors.green`),
    "--button-success-disabled": theme(`colors.green`),
    "--button-success-outline": theme(`colors.green`),
    "--button-ghost": theme(`colors.transparent`),
  },

  // DARK Theme colors
  "[data-theme='dark']": {
    "--button-text": theme(`colors.base-6`),
    "--button-primary": theme(`colors.purple`),
    "--button-primary-outline": theme(`colors.purple`),
    "--button-secondary": theme(`colors.dark-purple`),
    "--button-secondary-outline": theme(`colors.dark-purple`),
    "--button-warning-white": theme(`colors.white`),
    "--button-warning-white-outline": theme(`colors.white`),
    "--button-warning": theme(`colors.red`),
    "--button-warning-disabled": theme(`colors.light-red`),
    "--button-warning-outline": theme(`colors.red`),
    "--button-disabled": theme(`colors.light-purple`),
    "--button-ghost": theme(`colors.transparent`),
  },
})
